<template>
  <div class="global-atmosphere" aria-hidden="true">
    <div class="aurora aurora-a"></div>
    <div class="aurora aurora-b"></div>
    <div class="aurora aurora-c"></div>
    <div class="grid-layer"></div>
    <div class="grain-layer"></div>
  </div>
</template>

<style>
.global-atmosphere {
  position: fixed;
  inset: 0;
  z-index: var(--layer-atmosphere, 0);
  overflow: hidden;
  pointer-events: none;
  contain: layout paint;
}

.aurora {
  position: absolute;
  border-radius: 9999px;
  filter: blur(80px);
  opacity: 0.26;
  animation: drift 20s ease-in-out infinite alternate;
}

.aurora-a {
  width: 48vw;
  height: 48vw;
  min-width: 360px;
  min-height: 360px;
  top: -16vh;
  left: -10vw;
  background: radial-gradient(circle at 35% 35%, rgba(99, 102, 241, 0.8) 0%, rgba(99, 102, 241, 0) 70%);
}

.aurora-b {
  width: 42vw;
  height: 42vw;
  min-width: 320px;
  min-height: 320px;
  top: 18vh;
  right: -12vw;
  background: radial-gradient(circle at 65% 40%, rgba(14, 165, 233, 0.72) 0%, rgba(14, 165, 233, 0) 70%);
  animation-delay: -6s;
}

.aurora-c {
  width: 38vw;
  height: 38vw;
  min-width: 280px;
  min-height: 280px;
  bottom: -14vh;
  left: 26vw;
  background: radial-gradient(circle at 55% 55%, rgba(236, 72, 153, 0.52) 0%, rgba(236, 72, 153, 0) 70%);
  animation-delay: -11s;
}

.grid-layer {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 84px 84px;
  mask-image: radial-gradient(circle at 50% 36%, black 12%, transparent 70%);
  opacity: 0.28;
}

.grain-layer {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.12) 0.5px, transparent 0.5px);
  background-size: 4px 4px;
  opacity: 0.06;
}

@keyframes drift {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(2vw, -3vh, 0) scale(1.06);
  }
  100% {
    transform: translate3d(-2vw, 2vh, 0) scale(0.96);
  }
}

body.light .global-atmosphere .grid-layer {
  background-image:
    linear-gradient(rgba(37, 99, 235, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(124, 58, 237, 0.05) 1px, transparent 1px);
  opacity: 0.18;
}

body.light .global-atmosphere .aurora {
  opacity: 0.2;
}

body.light .global-atmosphere .grain-layer {
  opacity: 0.025;
}

@media (prefers-reduced-motion: reduce) {
  .aurora {
    animation: none;
  }
}
</style>
